/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect } from 'react';

function AllDepartment() {
  const { data, setData } = useDataContext();

  useEffect(() => {
    const fetchData = () => {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch("https://api-hr.boonsiri.co.th/amphures", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setData(prevData => ({...prevData, allAmphures: result.data}));
        })
        .catch((error) => console.error(error));
    };

    // เรียก fetchData ทันทีที่ component mount
    fetchData();

    // ตั้ง interval เพื่อเรียก fetchData ทุก ๆ 5 วินาที
    

    // ทำการ cleanup interval เมื่อ component ถูก unmount
    
  }, [setData]);

  return null;
}

export default AllDepartment;
